import React from 'react';

import { MobileAccountLookupStep } from './MobileAccountLookupStep';
import { StepNames } from 'shared/helpers';

export const StepComponents = {
    [StepNames.MobileAccountLookup]: <MobileAccountLookupStep />,
};
